import { t } from 'i18next';
import i18next from 'i18next';

// export const MARKET_TOP_MENU = ["Overview", "Trading Data"];
// 언어에 따라 다른 형식의 메뉴를 반환하는 함수
export const getMarketTopMenu = () => {
  // 한국어인 경우
  if (i18next.language === 'ko') {
    return ['시장 개요'];
  }
  // 영어 및 기타 언어
  else {
    return ['Overview'];
  }
};

export const MARKET_BOTTOM_MENU = [
  'Spot/Margin Market',
  'Futures Market',
  'Derivatives',
  'New Listing',
];

// export const DEPOSIT_MENU = ["P2P",  "Crypto Deposit"]; //"One-Click Buy",

// 언어에 따라 다른 형식의 입금 메뉴를 반환하는 함수
export const getDepositMenu = () => {
  // 한국어인 경우
  if (i18next.language === 'ko') {
    return ['암호화폐 구매/판매'];
  }
  // 영어 및 기타 언어
  else {
    return ['Crypto Buy/Sell'];
  }
};

// 현재 DEPOSIT_MENU를 저장할 변수
let currentDepositMenu = getDepositMenu();

// 언어 변경 이벤트 리스너 등록 (DEPOSIT_MENU용)
i18next.on('languageChanged', () => {
  // 언어가 변경되면 DEPOSIT_MENU 업데이트
  currentDepositMenu = getDepositMenu();
});

// 기존 상수 대신 함수를 통해 항상 최신 값을 제공하는 getter 객체
export const DEPOSIT_MENU = new Proxy([], {
  get: function (target, prop) {
    // 배열 메서드 호출 시 처리
    if (
      typeof prop === 'string' &&
      typeof currentDepositMenu[prop] === 'function'
    ) {
      return function (...args: any[]) {
        return currentDepositMenu[prop](...args);
      };
    }
    // 일반 속성 접근
    return currentDepositMenu[prop];
  },
});

export const BOT_PAYMENT = ['AI Stategy', 'Manual'];

export const DERIVATIVE_MENU = ['Copy Trading', 'Copy Trading Pro'];

export const getMoreMenu = () => [
  t('aboutUs'),
  t('institutional'),
  t('termsAndConditions'),
  t('guide'),
  // "Loans",
  // "Referral",
  // "Security of funds",
  // "Pay",
  // "Earn",
];

// MORE_MENU에 대응하는 라우트를 반환하는 함수
export const getMoreMenuRoutes = () => {
  const menu = getMoreMenu();
  return {
    [menu[0]]: '/about-us',        // aboutUs
    [menu[1]]: '/institutional',   // institutional
    [menu[2]]: '/terms-and-conditions', // termsAndConditions
    [menu[3]]: '/guide',           // guide
    default: '/about-us',
  };
};

// 현재 MORE_MENU를 저장할 변수
let currentMoreMenu = getMoreMenu();
let currentMoreMenuRoutes = getMoreMenuRoutes();

// 언어 변경 이벤트 리스너 등록
i18next.on('languageChanged', () => {
  // 언어가 변경되면 MORE_MENU와 routes 업데이트
  currentMoreMenu = getMoreMenu();
  currentMoreMenuRoutes = getMoreMenuRoutes();
});

// 기존 상수 대신 함수를 통해 항상 최신 값을 제공하는 getter 객체
export const MORE_MENU = new Proxy([], {
  get: function (target, prop) {
    // 배열 메서드 호출 시 처리
    if (
      typeof prop === 'string' &&
      typeof currentMoreMenu[prop] === 'function'
    ) {
      return function (...args: any[]) {
        return currentMoreMenu[prop](...args);
      };
    }
    // 일반 속성 접근
    return currentMoreMenu[prop];
  },
});

// MORE_MENU_ROUTES도 동일한 방식으로 Proxy 구현
export const MORE_MENU_ROUTES = new Proxy({}, {
  get: function (target, prop: string | symbol) {
    if (typeof prop === 'string') {
      return currentMoreMenuRoutes[prop];
    }
    return undefined;
  },
}) as Record<string, string>;

export const TRADE_MENU = ['Copy Trading', 'Bots', 'Convert'];

// 카피 트레이딩 페이지 내부 탭 메뉴 (기본 - 모든 사용자)
export const getCopyTradeMenu = () => {
  const menus = [
    t('discover'),        // 탐색
    t('following'),       // 팔로잉
    t('orderHistory'),    // 주문 이력
    // 정산 탭은 MVP에서 제외
  ];
  return menus.filter(Boolean); // undefined 제거
};

// 리더 전용 탭 메뉴
export const getLeaderTabs = () => {
  const tabs = [
    t('myPortfolio'),     // 내 포트폴리오
    t('myFollowers'),     // 내 팔로워
    // 수익 탭은 MVP에서 제외 (API 없음)
  ];
  return tabs.filter(Boolean); // undefined 제거
};

// 현재 카피 트레이딩 메뉴를 저장할 변수
let currentCopyTradeMenu = getCopyTradeMenu();
let currentLeaderTabs = getLeaderTabs();

// 언어 변경 이벤트 리스너 등록
i18next.on('languageChanged', () => {
  currentCopyTradeMenu = getCopyTradeMenu();
  currentLeaderTabs = getLeaderTabs();
});

// Proxy를 통해 동적으로 최신 값 제공
export const COPY_TRADE_MENU = new Proxy([], {
  get: function (target, prop) {
    if (
      typeof prop === 'string' &&
      typeof currentCopyTradeMenu[prop] === 'function'
    ) {
      return function (...args: any[]) {
        return currentCopyTradeMenu[prop](...args);
      };
    }
    return currentCopyTradeMenu[prop];
  },
});

export const LEADER_TABS = new Proxy([], {
  get: function (target, prop) {
    if (
      typeof prop === 'string' &&
      typeof currentLeaderTabs[prop] === 'function'
    ) {
      return function (...args: any[]) {
        return currentLeaderTabs[prop](...args);
      };
    }
    return currentLeaderTabs[prop];
  },
});

// 봇 트레이딩 메뉴 (바이낸스 스타일)
export const getBotTradingMenu = () => [
  t('marketplace'),     // 마켓플레이스
  t('myBots'),          // 내 봇
  t('tradingHistory'),  // 거래 내역
  t('createBot'),       // 봇 생성
];

// 현재 봇 트레이딩 메뉴를 저장할 변수
let currentBotTradingMenu = getBotTradingMenu();

// 언어 변경 이벤트 리스너 등록
i18next.on('languageChanged', () => {
  currentBotTradingMenu = getBotTradingMenu();
});

// Proxy를 통해 동적으로 최신 값 제공
export const BOT_TRADING_MENU = new Proxy([], {
  get: function (target, prop) {
    if (
      typeof prop === 'string' &&
      typeof currentBotTradingMenu[prop] === 'function'
    ) {
      return function (...args: any[]) {
        return currentBotTradingMenu[prop](...args);
      };
    }
    return currentBotTradingMenu[prop];
  },
});
